import { Dispatch } from "redux";
import { setWorkflowTemplates, setWorkflowTemplatesLoading } from "@redux/actions/workflow-templates-actions";
import { FormattedWorkflowTemplate } from "@idw-types/data/reference-data/generic";
import { getWorkflowTemplatesRequest } from "@requests/management-console/get-workflow-templates";
import { formatWorkflowTemplates } from "@formatters/workflow-templates/workflow-template-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany } from "@idw-types/data/reference-data/axn";

export const getWorkflowTemplatesReduxRequest = (dispatch: Dispatch) => async (
    axnCompanies: Array<AxnCompany>
): Promise<Array<FormattedWorkflowTemplate>> => {
    dispatch(setWorkflowTemplatesLoading(true));
    const { data, error } = await getWorkflowTemplatesRequest();
    if (data?.workflowTemplates) {
        const formattedWorkflowTemplates = formatWorkflowTemplates(data.workflowTemplates, axnCompanies);
        dispatch(setWorkflowTemplates(formattedWorkflowTemplates));
        return formattedWorkflowTemplates;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getWorkflowTemplates.error.title,
                resources.requests.getWorkflowTemplates.error.message
            );
        }
        dispatch(setWorkflowTemplatesLoading(false));
        return null;
    }
};